import React from "react";

import { GenericTooltip } from "@components/tooltip-container";
import { enumType } from "@north-beam/nb-common";
import { Select } from "@shared/selects";

const SumModeType = enumType({
  enumObject: {
    AveragedPerCustomer: "Averaged per customer (Weighted)",
    TotalOverAllCustomers: "Total over all customers",
  },
  keyOrder: ["AveragedPerCustomer", "TotalOverAllCustomers"],
});
export const SumModeEnum = SumModeType.enum;
export type SumMode = keyof typeof SumModeEnum;
export const defaultSumMode = SumModeType.keyOrder[0];

const sumModeDescription = {
  AveragedPerCustomer:
    "Weighted by the number of customers and averaged over all customers",
  TotalOverAllCustomers: "The total sum over all customers",
};

interface SumModeSelectProps {
  className?: string;
  sumMode: SumMode;
  isLoading: boolean;
  isDisabled?: boolean;
  setSumMode: (sumMode: SumMode) => void;
}

export const SumModeSelect = ({
  className,
  isLoading,
  isDisabled,
  sumMode,
  setSumMode,
}: SumModeSelectProps) => {
  return (
    <GenericTooltip
      placement="top"
      content={sumModeDescription[sumMode]}
      destroyTooltipOnHide={true}
    >
      <Select
        className={className}
        label="AVERAGE VS TOTAL"
        isLoading={isLoading}
        isDisabled={isDisabled}
        onChange={setSumMode}
        options={SumModeType.reactSelectOptions}
        value={sumMode}
      />
    </GenericTooltip>
  );
};
